/*
 * @Author: Nora Galvin
 * @Date: 2020-08-21 08:51:35
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-24 11:02:14
 */
import template from './template.html';
import type { TypeInputEmitData } from '@/app/editor/sidebar/interactions/animations/type';

/**
 * CheckboxCBntrol
 */
export default class CheckBoxControl {
  _$input: JQuery;
  _$interactionTab: JQuery;
  _$interactionPanel: JQuery;
  _options: any;

  /**
   * constructor
   * @param $input ..
   * @param options ..
   */
  constructor($input: JQuery, options?: any) {
    this._$input = $input;
    this._$interactionTab = jQuery('.simple-tabs');
    this._$interactionPanel = this._$interactionTab.find('.interactions-panel');
    this._options = options;
    this.renderTemplate();
  }

  /**
   * Render Checkbox to Template
   * @returns void
   */
  renderTemplate(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    this._$input.hide();
    const html = template();

    this._$input.off('change').on('change', function () {
      const key = _this._$input.data('key') || '';
      const value = _this._$input.is(':checked');
      const inputType = _this._$input.data('inputtype') || '';
      const configType = _this._$input.attr('name') || '';

      const data: TypeInputEmitData = {
        key: key,
        value: value,
        inputType: inputType,
        type: configType,
      };
      if (_this._options && _this._options.onChange) {
        _this._options.onChange(data);
      }
    });

    const $html = $(html);

    this._$input.after($html);
  }

  /**
   * Set value to select
   * @param val ..
   * @returns void
   */
  setValue(val: string | number): void {
    this._$input.val(val);
  }
}
